module.exports = __webpack_public_path__ + "img/typography.eb5c3c55.png";